import {
  GeneralObject,
  TUserListPayload,
  TUsersListResponse,
  UserRole,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const userService = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addUserDetails: builder.mutation<
      GeneralObject,
      GeneralObject
    >({
      query: (data) => {
        return {
          url: 'app-users',
          method: 'POST',
          data,
        };
      },
    }),
    updateUserDetails: builder.mutation<
      GeneralObject,
      GeneralObject
    >({
      query: (data) => {
        return {
          url: 'app-users',
          method: 'PUT',
          data,
        };
      },
    }),
    getAllUserRoles: builder.query<UserRole[], void>({
      query: () => ({
        method: 'GET',
        url: 'app-roles?size=100&page=0',
      }),
    }),
    getUserDetails: builder.query<
      TUsersListResponse,
      number
    >({
      query: (id) => ({
        method: 'GET',
        url: `app-users/${id}`,
      }),
    }),
    getLoginUserDetails: builder.query<GeneralObject, void>(
      {
        query: () => ({
          method: 'GET',
          url: 'app-users',
        }),
      }
    ),
    getAllUsersDetails: builder.query<
      { data: TUsersListResponse[]; totalCount: number },
      TUserListPayload
    >({
      query: (params) => ({
        method: 'GET',
        url: `app-users/list`,
        params,
      }),
      transformResponse: (
        data: TUsersListResponse[],
        meta: Response
      ) => {
        const totalCount =
          meta.headers.get('X-total-count');
        return {
          data,
          totalCount: Number(totalCount ? totalCount : 0),
        };
      },
    }),
    changeVerifierStatus: builder.mutation<
      GeneralObject,
      { userId: number; status: string }
    >({
      query: ({ userId, status }) => {
        return {
          url: `kycVerifier/changeVerifierStatus/${userId}/${status}`,
          method: 'POST',
        };
      },
    }),
  }),
});

export const {
  useGetUserDetailsQuery,
  useAddUserDetailsMutation,
  useUpdateUserDetailsMutation,
  useGetAllUserRolesQuery,
  useGetLoginUserDetailsQuery,
  useChangeVerifierStatusMutation,
  useGetAllUsersDetailsQuery,
} = userService;
